import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    activeCallLog: null,
};

const activeCallLogSlice = createSlice({
    name: 'activeCallLogData',
    initialState,
    reducers: {
        setActiveCallLog: (state, action) => {
            state.activeCallLog = action.payload;
        },
        clearActiveCallLog: state => {
            state.activeCallLog = null;
        },
    },
});

export const { setActiveCallLog, clearActiveCallLog } = activeCallLogSlice.actions;
export default activeCallLogSlice.reducer;
